import { useEffect } from 'react';

import { Modal, ModalBody, ModalHeader, Text } from '@change/ds-core-ui';

import { Translate, useI18n } from '@change-corgi/core-react/i18n';

import { Share, preloadShare } from '../Share';

import { MobileModalContextDecorator } from './shared/MobileModalContextDecorator';
import type { MobileModalContext } from './shared/types';

const PRELOAD_SHARE_DELAY = 5000;

const MobileShareModalInner = ({ isOpen, setIsOpen }: { isOpen: boolean; setIsOpen: (isOpen: boolean) => void }) => {
	const { translate } = useI18n();
	return (
		<Modal
			isOpen={isOpen}
			onOpenChange={setIsOpen}
			onClose={() => {}}
			closeButtonAriaLabel={translate('corgi.components.modal.close_button')}
			fullScreenOnMobile
			enableTransitionAnimations={false}
			data-qa="share-modal"
		>
			<ModalHeader
				title={
					<Text fontWeight="bold">
						<Translate value="fe.components.petition_share.action" />
					</Text>
				}
			/>
			<ModalBody>
				<div className="w-full px-0.5" data-qa="share-modal-container">
					<Share forMobileView onShareClickWithModalOpen={() => setIsOpen(false)} />
				</div>
			</ModalBody>
		</Modal>
	);
};

export const MobileShareModal = ({
	context,
	isOpen,
	setIsOpen,
}: {
	context: MobileModalContext;
	isOpen: boolean;
	setIsOpen: (isOpen: boolean) => void;
}) => {
	return (
		<MobileModalContextDecorator {...context}>
			<MobileShareModalInner isOpen={isOpen} setIsOpen={setIsOpen} />
		</MobileModalContextDecorator>
	);
};

export function usePreloadMobileShareModal(): void {
	useEffect(() => {
		const timeout = window.setTimeout(() => {
			void preloadShare();
		}, PRELOAD_SHARE_DELAY);

		return () => window.clearTimeout(timeout);
	});
}
